import AboutSection from "../../Components/HomeSections/AboutSection";
// import AttorneySection from "../../Components/HomeSections/AttorneySection";
import HeroSection from "../../Components/HomeSections/HeroSection";
import PracticeAreas from "../../Components/HomeSections/Practices";
import TestimonialSlider from "../../Components/HomeSections/Testimonials";
import WhyChooseUs from "../../Components/HomeSections/WhyChooseUs";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import ServicesList from "../../Components/Services/ServicesList";
import { Helmet } from "react-helmet";

const HomePage =()=>{
    return(
        <>
         <Helmet>
        <title> Home - Trusted Legal Services</title>
        <meta
          name="description"
          content="Advocate Saurav Dagar Chambers: Expert legal solutions, trusted lawyers, and decades of excellence in serving clients. Explore our services and success stories."
        />
        <meta
          name="keywords"
          content="Advocate Saurav Dagar, Law Firm, Lawyers, Legal Services, Legal Expertise, Justice"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

        <Header/>
        <HeroSection/>
        <AboutSection/>
        <PracticeAreas/>
        <WhyChooseUs/>
        {/* <AttorneySection/> */}
        <TestimonialSlider/>
        <ServicesList/>
        <Footer/>
        </>
    )
}

export default HomePage;